(function () {
  var STORAGE_KEY = 'mys_popup_v1';
  var KLAVIYO_KEY = 'VY57Dr';
  var DELAY = 9000;

  function init() {
    if (localStorage.getItem(STORAGE_KEY)) return;
    var overlay = document.getElementById('mysPopupOverlay');
    if (!overlay) return;

    setTimeout(function () {
      overlay.classList.add('is-active');
    }, DELAY);

    document.getElementById('mysPopupClose').addEventListener('click', dismiss);
    document.getElementById('mysPopupSkip').addEventListener('click', dismiss);
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) dismiss();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') dismiss();
    });

    document.getElementById('mysPopupBtn').addEventListener('click', submit);
    document.getElementById('mysPopupEmail').addEventListener('keydown', function (e) {
      if (e.key === 'Enter') submit();
    });
  }

  function submit() {
    var emailEl = document.getElementById('mysPopupEmail');
    var errorEl = document.getElementById('mysPopupError');
    var btn = document.getElementById('mysPopupBtn');
    var email = emailEl.value.trim();

    errorEl.textContent = '';

    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      errorEl.textContent = 'Por favor escribe un email válido.';
      emailEl.focus();
      return;
    }

    btn.disabled = true;
    btn.textContent = '...';

    // Via _learnq (Klaviyo JS ya cargado por la app)
    window._learnq = window._learnq || [];
    window._learnq.push(['identify', {
      '$email': email,
      '$consent': ['email']
    }]);
    window._learnq.push(['track', 'Popup Bienvenida MYS', {
      'discount_code': 'BIENVENIDA10',
      'source': 'Popup Mery You Stone'
    }]);

    // Via API REST de Klaviyo como respaldo
    fetch('https://a.klaviyo.com/client/events/?company_id=' + KLAVIYO_KEY, {
      method: 'POST',
      headers: {
        'content-type': 'application/json',
        'revision': '2024-02-15'
      },
      body: JSON.stringify({
        data: {
          type: 'event',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: { email: email }
              }
            },
            metric: {
              data: {
                type: 'metric',
                attributes: { name: 'Popup Bienvenida MYS' }
              }
            },
            properties: {
              discount_code: 'BIENVENIDA10',
              source: 'Popup Mery You Stone'
            }
          }
        }
      })
    })
    .finally(showSuccess);
  }

  function showSuccess() {
    var content = document.getElementById('mysPopupFormContent');
    var success = document.getElementById('mysPopupSuccess');
    if (content) content.style.display = 'none';
    if (success) success.style.display = 'block';
    localStorage.setItem(STORAGE_KEY, '1');
  }

  function dismiss() {
    var overlay = document.getElementById('mysPopupOverlay');
    if (overlay) overlay.classList.remove('is-active');
    localStorage.setItem(STORAGE_KEY, '1');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
